module.exports = __webpack_public_path__ + "img/city-catna-algiers.bd19b76.jpg";